// extracted by mini-css-extract-plugin
export default {"container":"PromoCodeInput_container__+IRTq","discountText":"PromoCodeInput_discountText__rzYsU","removeIcon":"PromoCodeInput_removeIcon__6aqLM"};